import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { Link } from '@core/models/atomics.model';

@Component({
  selector: 'cx-link',
  imports: [CommonModule, RouterModule],
  templateUrl: './link.component.html',
  styleUrl: './link.component.scss',
})
export class LinkComponent {
  @Input({ required: true }) link!: Link;
  @Input() styleClass = '';

  private readonly router = inject(Router);

  onClick(event: Event) {
    if (!this.link.isExternal && this.link.url) {
      event.preventDefault();
      this.router.navigateByUrl(this.link.url);
    }
  }
}
